'use client';
import { useState } from 'react';
import Image from 'next/image';
import { ParallaxBannerWrapper } from '@overlapdev/wrappers';
import { VideoType } from '@overlapdev/types';
import { Video } from '@overlapdev/elements';
import { CloseSVG } from 'components/svg';

const ParallaxVideo = ({ video }: { video: VideoType }) => {
	//__Variables
	const { fallback_image } = video || {};

	//__State
	const [play, setPlay] = useState(false);
	const [show, setShow] = useState(false);

	//__Functions
	const open = () => {
		setPlay(true);
		//Wait for animation before unmounting Video
		setTimeout(() => {
			setShow(true);
		}, 50);
	};

	const close = () => {
		setShow(false);
		//Wait for animation before unmounting Video
		setTimeout(() => {
			setPlay(false);
		}, 500);
	};

	if (!video || !fallback_image?.url) return null;
	return (
		<div className='relative'>
			<div className='cursor-pointer' role='button' onClick={() => open()}>
				<ParallaxBannerWrapper style={{ height: 'calc(100svh - 94px)' }} className='parallax_banner' layers={[{ children: <Image src={fallback_image.url} alt={fallback_image.alt} fill className='object-cover object-top' />, easing: [0, 0, 1, 1], shouldAlwaysCompleteAnimation: true, speed: -15, translateY: ['150px', '-150px'] }]} />
			</div>
			{play ? (
				<div className={`absolute bg-black h-full top-0 transition-ease w-full ${show ? 'opacity-100' : 'opacity-0'}`}>
					<Video video_className='h-full w-full' video={video} />
					<div
						className='absolute cursor-pointer right-5 top-5'
						onClick={(e) => {
							e.stopPropagation();
							close();
						}}
						role='button'
					>
						<CloseSVG stroke='#fff' width={20} />
					</div>
				</div>
			) : (
				''
			)}
		</div>
	);
};

export default ParallaxVideo;
